import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Head } from "../../../../components/core";
import {
  NotifyType,
  useNotifyContext,
} from "../../../../contexts/NotifyContext";
import {
  ADD_DOCK,
  DockForm,
  GET_DOCKS,
} from "../../../../graphql/fleets/settings/docks";
import Form from "./components/Form";

const DockCreate = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => {
  const { addNotify } = useNotifyContext();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [createDock] = useMutation(ADD_DOCK, {
    refetchQueries: [{ query: GET_DOCKS }],
  });

  const handleSubmit = (
    values: DockForm,
    actions: { setSubmitting: (arg0: boolean) => void }
  ) => {
    createDock({
      variables: {
        name: values.name,
        vehicleIds: values.vehicleIds,
        status: values.status,
      },
    })
      .then(({ data }) => {
        actions.setSubmitting(false);
        if (data?.dockCreate) {
          addNotify({
            type: NotifyType.SUCCESS,
            title: "Dock created successfully",
          });
          return navigate(`/fleets/settings/docks`);
        } else {
          addNotify({
            type: NotifyType.ERROR,
            title: "Dock creation failed",
            message: "Something went wrong, please try again later",
          });
        }
      })
      .catch((error) => {
        actions.setSubmitting(false);
        addNotify({
          type: NotifyType.ERROR,
          title: "Dock creation failed",
          message: error.message,
        });
      });
  };

  return (
    <>
      <Head
        title={DockCreateResource.name}
        heading="Docks"
        breadcrumbs={[
          ...breadcrumbs,
          {
            name: "Docks",
            href: "/fleets/settings/docks",
          },
          {
            name: DockCreateResource.name,
            href: null,
          },
        ]}
      />

      <div className="mx-auto max-w-3xl py-6 sm:py-8">
        <div className="rounded-xl bg-greyish p-5">
          <div className="mb-6 sm:flex sm:items-center md:mb-8">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-medium text-gray-900">
                {t("heading_create_dock")}
              </h1>
              <p className="mt-2 text-sm text-gray-700">
                {t("description_create_dock")}
              </p>
            </div>
          </div>

          <Form
            initialValues={{
              name: "",
              vehicleIds: [],
              status: true,
            }}
            vehicles={[]}
            onSubmit={handleSubmit}
            actionLabel={t("text_create")}
          />
        </div>
      </div>
    </>
  );
};

export default DockCreate;
export const DockCreateResource: ResourceProps = {
  name: "Create Dock",
  description: "Create a new dock",
  access: ["create-docks"],
  path: "docks/add",
};
